import { useState, useEffect, useCallback } from 'react';
import api from '../../../services/api';

// P1 Görev Paketi A — çalışan PIP self-servis API'si ([Authorize]-only uçlar):
//   GET v1/pips/my        — çalışanın görünür PIP'leri (yalnız active|completed_*;
//                            taslak/iptal edilmiş süreçler BE tarafından gizlenir)
//   GET v1/pips/my/{id}   — tekil detay (hedefler + check-in'ler)
// "current": aktif süreç varsa O; yoksa en son tamamlanmış (BE listesi aktif
// önce + CreateDate DESC sıralı döner) — useMyCalibration deseniyle aynı.
export const useMyPip = () => {
  const [list, setList] = useState([]);
  const [current, setCurrent] = useState(null);
  const [detail, setDetail] = useState(null);
  const [fetching, setFetching] = useState(true);
  const [detailFetching, setDetailFetching] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setFetching(true);
    api.get('/v1/pips/my', { skipErrorToast: true })
      .then((res) => {
        if (cancelled) return;
        const rows = res.data?.status ? (res.data.data || []) : [];
        setList(rows);
        const active = rows.find((r) => r.status === 'active');
        setCurrent(active || rows[0] || null);
      })
      .catch(() => { if (!cancelled) { setList([]); setCurrent(null); } })
      .finally(() => { if (!cancelled) setFetching(false); });
    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    if (!current) { setDetail(null); return undefined; }
    let cancelled = false;
    setDetailFetching(true);
    api.get(`/v1/pips/my/${current.id}`, { skipErrorToast: true })
      .then((res) => { if (!cancelled) setDetail(res.data?.status ? res.data.data : null); })
      .catch(() => { if (!cancelled) setDetail(null); })
      .finally(() => { if (!cancelled) setDetailFetching(false); });
    return () => { cancelled = true; };
  }, [current]);

  const selectPip = useCallback((id) => {
    setCurrent((prev) => (prev?.id === id ? prev : (list.find((r) => r.id === id) || prev)));
  }, [list]);

  return {
    list, current, detail, fetching, detailFetching, selectPip,
  };
};

export default useMyPip;
